import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Spin } from 'antd';
import NavbarNew from 'src/components/userComponents/navbar/NavbarNew'; // New redesigned Navbar
import { SignInPage } from 'src/pages/signIn/SignIn';
import { SignUpPage } from 'src/pages/signUp/SignUp';
import { ForgotPassword } from 'src/pages/signIn/ForgotPassword';
import { ResetPassword } from 'src/pages/signIn/ResetPassword';

const AboutNew = React.lazy(() => import('src/pages/user/AboutNew'));
const CartNew = React.lazy(() => import('src/pages/user/CartNew'));
const CheckoutNew = React.lazy(() => import('src/pages/user/CheckoutNew'));
const ContactNew = React.lazy(() => import('src/pages/user/ContactNew'));
const HomeNew = React.lazy(() => import('src/pages/user/HomeNew'));
const ProductDetailNew = React.lazy(() => import('src/pages/user/ProductDetailNew'));
const ProfilePage = React.lazy(() => import('src/pages/user/Profile').then(module => ({ default: module.ProfilePage })));
const ShopNew = React.lazy(() => import('src/pages/user/ShopNew'));
const VendorProductPage = React.lazy(() => import('src/pages/user/VendorProductPage'));
const BlogNew = React.lazy(() => import('src/pages/user/BlogNew'));
const BlogDetail = React.lazy(() => import('src/pages/user/BlogDetail'));
export const UserRoutes = () => {
    return (
        <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>}>
            <Routes>
                <Route path="/" element={<NavbarNew />}>
                    <Route index element={<HomeNew />} />
                    <Route path="shop/" element={<ShopNew />} />
                    <Route path="products/:id" element={<ProductDetailNew />} />
                    <Route path="contact" element={<ContactNew />} />
                    <Route path="checkout" element={<CheckoutNew />} />
                    <Route path="about" element={<AboutNew />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="cart" element={<CartNew />} />
                    <Route path="vendor/products" element={<VendorProductPage />} />
                    <Route path="blog" element={<BlogNew />} />
                    <Route path="blog/:slug" element={<BlogDetail />} />
                </Route>
                <Route path="/signIn" element={<SignInPage />} />
                <Route path="/signUp" element={<SignUpPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:id/:token" element={<ResetPassword />} />
            </Routes>
        </Suspense>
    );
};
